import { render } from "./RtpiNearMe.vue?vue&type=template&id=5f2d657c&lang=pug"
import script from "./RtpiNearMe.vue?vue&type=script&lang=ts"
export * from "./RtpiNearMe.vue?vue&type=script&lang=ts"

import "./RtpiNearMe.vue?vue&type=style&index=0&id=5f2d657c&lang=scss"
script.render = render

export default script